import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2dbb44d4&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dbb44d4')) {
      api.createRecord('2dbb44d4', component.options)
    } else {
      api.reload('2dbb44d4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2dbb44d4&", function () {
      api.rerender('2dbb44d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/setting/cohort/index.vue"
export default component.exports